import {
  wrapperStyles,
  containerStyles,
  tilesWrapperStyles,
  tilesWrapperMobileStyles
} from 'components/Templates/commonStyles/DefaultCssValues';

import {
  sectionWrapperStyles,
  sectionWrapperMobileStyles,
  wrapperWithMarginStyles,
  typoLargeNumber,
  typoHeader,
  typoSmall,
  sectionWrapperTabletStyles,
  typoHeaderMobile,
  wrapperWithMarginTabletStyles
} from 'components/Templates/styles/Red/commonObjectsStyles';

/* eslint-disable */
export default {
  wrapper: {
    '0': {
      ...wrapperStyles,
      ...sectionWrapperStyles,
      'background-color': '{sectionBackgroundColor}'
    },
    '76_8' : {
      ...sectionWrapperTabletStyles
    },
    '37_5' : {
      ...sectionWrapperMobileStyles
    }
  },
  sectionTitle: {
    '0': {
      ...typoHeader,
      'color': '{invertedBackgroundColor}'
    },
    '76_8' : {
      ...typoHeaderMobile,
      'margin-bottom' : '0.5rem',
      'color': '{invertedBackgroundColor}'
    },
  },
  wrapperWithMargin: {
    '0': {
      ...wrapperWithMarginStyles
    },
    '76_8' : {
      ...wrapperWithMarginTabletStyles
    }
  },
  countdownsWrapper: {
    '0': {
      ...tilesWrapperStyles,
      'margin-top' : '6rem',
      'justify-content': 'space-around'
    },
    '37_5' : {
      ...tilesWrapperMobileStyles,
    }
  },
  countdownTile: {
    '0': {
      'display': 'flex',
      'flex-direction': 'column',
      'align-items': 'center',
    },
    '37_5' : {
      'width': '100%',
      'margin-bottom' : '2rem'
    }
  },
  countdownSubtitleDays: {
    '0': {
      ...typoSmall,
      'position': 'relative',
      'display': 'block',
      'margin-top' : '3rem',
      'text-align': 'center'
    },
    '37_5': {
      'text-align': 'left'
    }
  },
  countdownSubtitleHours: {
    '0': {
      ...typoSmall,
      'position': 'relative',
      'display': 'block',
      'margin-top' : '3rem',
      'text-align': 'center'
    },
    '37_5': {
      'text-align': 'left'
    }
  },
  countdownSubtitleMinutes: {
    '0': {
      ...typoSmall,
      'position': 'relative',
      'display': 'block',
      'margin-top' : '3rem',
      'text-align': 'center'
    },
    '37_5': {
      'text-align': 'left'
    }
  },
  countdownSubtitleSeconds: {
    '0': {
      ...typoSmall,
      'position': 'relative',
      'display': 'block',
      'margin-top' : '3rem',
    }
  },
  countdownNumberDays: {
    '0': {
      ...typoLargeNumber,
      'min-width': '14rem',
      'text-align': 'center',
    }
  },
  countdownNumberHours: {
    '0': {
      ...typoLargeNumber,
      'min-width': '14rem',
      'text-align': 'center',
    }
  },
  countdownNumberMinutes: {
    '0': {
      ...typoLargeNumber,
      'min-width': '14rem',
      'text-align': 'center',
    }
  },
  countdownNumberSeconds: {
    '0': {
      ...typoLargeNumber,
      'min-width': '14rem',
      'text-align': 'center',
    }
  }
};
